export default __webpack_public_path__ + "static/media/synes-banner.9a5486ed.png";